import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { LabelPosition, Switch } from "shared/components/forms/Switch";
import { FilterVerticalIcon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from "shared/components/Popover";
import { displayTabNames } from "./constants";
import { resolveColumnLabel } from "./utils";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";

type ColumnsMenuProps = {
  isMobile: boolean;
  columnsData: {
    id: string;
    label: string;
    checked: boolean;
    disabled: boolean;
  }[];
  onColumnToggle: (id: string, checked: boolean) => void;
  disabled?: boolean;
} & (
  | { activeTab: string; contextLabel?: never; contextNoun?: never }
  | { activeTab?: never; contextLabel: string; contextNoun: "tab" | "table" }
);

export const ColumnsMenu = ({
  activeTab,
  contextLabel,
  contextNoun,
  isMobile,
  columnsData,
  onColumnToggle,
  disabled
}: ColumnsMenuProps) => {
  const { Property } = useUnitsPropertiesDictionary();

  const headingLabel =
    contextLabel ?? (activeTab ? displayTabNames[activeTab] : "");
  const headingNoun = contextNoun ?? "tab";

  return (
    <Popover placement="bottom">
      <PopoverTrigger asChild>
        <IconButton
          size={isMobile ? IconButtonSize.BASE : IconButtonSize.SM}
          variant={IconButtonVariant.BASE}
          HugeIcon={FilterVerticalIcon}
          disabled={disabled}
        />
      </PopoverTrigger>

      <PopoverContent
        className="mt-2 py-5 px-3 z-20 w-[360px] origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none
                  absolute left-0 md:left-1/2 md:-translate-x-1/2"
      >
        <h3 className="px-3 pb-4 text-sm text-content-200 font-medium">
          Column visibility on &lsquo;{headingLabel}&rsquo; {headingNoun}
        </h3>
        <div className="text-sm">
          {columnsData.map(
            (item) =>
              !item.disabled && (
                <div key={item.id} className="p-3">
                  <Switch
                    label={resolveColumnLabel(item.label, Property)}
                    checked={item.checked}
                    onChange={() => onColumnToggle(item.id, !item.checked)}
                    wrapperClassName="justify-between"
                    position={LabelPosition.Left}
                  />
                </div>
              )
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
